package io.horion.cv.api.datasource.job

import kotlinx.serialization.Serializable

@Serializable
data class SalaryRange(
    val min: Int,
    val max: Int,
    val currency: String = "CFA" // FCFA par défaut
)